// import axios from "axios"
import axios from "../../../constants/axios"
import { navigate } from "gatsby"

import endpoints from "../../../constants/endpoints"

import { formatDateToBackend } from "../../../utils/format-date-time"
import { getAndSetNavigable } from "../../../utils/checkNavigable"

export const PROFILE_IMAGE_UPLOAD = async (
  image_file,
  setProcessing,
  setErrors,
  dispatch,
  state,
  avatar
) => {
  setProcessing(true)
  try {
    if (!!image_file) {
      let formData = new FormData()
      formData.append("avatar", image_file, image_file.name)
      const res = await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_AVATAR_SUBMIT,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      if (res?.status?.toString() !== "200") {
        setErrors({
          message: "Image not valid",
          profile_image_not_uploaded: true,
        })
      }
      if (res?.status === 200) {
        dispatch({
          type: "PROFILE_VERIFIED",
          payload: {
            verified: state.hasProfile,
            data: {
              ...state?.profile,
              avatar,
            },
          },
        })
      }
    }
    setProcessing(false)
  } catch (err) {
    if (err.response && err.response.data && err.response.data.message) {
      setErrors({
        errors: err.response.data.message,
        profile_image_not_uploaded: true,
      })
    } else {
      setErrors({
        message: "Image not valid",
        profile_image_not_uploaded: true,
      })
    }
    setProcessing(false)
  }
}

export const PERSONAL_FORM_SUBMIT = async (
  data,
  setErrors,
  setProcessing,
  isContinue,
  dispatch
) => {
  try {
    const dataToBackend = {
      ...data,
      dob: formatDateToBackend(data.dob),
      permanent_address: 1,
    }
    delete dataToBackend.avatar
    const response = await axios.post(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_PERSONAL_SUBMIT,
      dataToBackend
    )
    if (response.status === 200) {
      getAndSetNavigable(["Personal", "Professional"], dispatch)
    }
    if (response.status === 200 && isContinue) {
      navigate("/candidate/professional")
      setProcessing(false)
    }
    if (response.status === 200 && !isContinue) {
      setErrors({ Success: "Data saved successfully." })
      setProcessing(false)
      setTimeout(() => {
        setErrors({})
      }, 2000)
    }
  } catch (err) {
    setProcessing(false)
    if (err.response && err.response.data && err.response.data.errors) {
      setErrors(err.response.data.errors)
    } else if (err.response && err.response.data && err.response.data.message) {
      setErrors({ errors: err.response.data.message })
    } else {
      return err
    }
  }
}

export const CANDIDATE_PERSONAL_DATA_FETCH = async (
  id,
  formState,
  setFormState,
  setLoading,
  dispatch
) => {
  try {
    const response = await axios.get(
      `${process.env.GATSBY_BASE_URL}${endpoints.CANDIDATE_PROFILE_PERSONAL_ROUTE}${id}/`
    )
    const { data } = response
    const personal_data = {
      first_name: data.personal.first_name,
      middle_name: data.personal.middle_name,
      last_name: data.personal.last_name,
      contact: data.personal.contact || "",
      website: data.personal.website,
      avatar: data.personal.avatar,
      current_address: data.personal.current_address,
      address: data.personal.address,
      dob: !!data?.personal.dob ? new Date(data.personal.dob) : null,
      gender: data.personal.gender,
      country: data.personal.country,
      permanent_address: data.personal.permanent_address,
      state: data.personal.city,
      cover_letter: data.personal.cover_letter,
      email: data.personal.email,
      province: data.personal.province,
    }
    setFormState({ ...formState, ...personal_data })
    dispatch({
      type: "PROFILE_VERIFIED",
      payload: {
        verified: data.personal.verified,
        data: personal_data,
      },
    })
    setLoading(false)
    return response
  } catch (err) {
    // dispatch({ type: "LOGOUT" })
    setLoading(false)
    if (err?.response?.status === 403) {
      dispatch({ type: "LOGOUT" })
    }
    return err?.response
  }
}

export const CANDIDATE_COUNTRY_FETCH = async (formState, setState, setCity) => {
  try {
    if (formState.country) {
      const res = await axios.get(
        process.env.GATSBY_BASE_URL +
          endpoints.CONFIG_COUNTRY_FETCH +
          formState.country +
          "/"
      )
      if (res.data) {
        if (res.data.province) {
          setState(res.data.province)
          if (formState.province) {
            const dist = res.data.province.find(
              prov => prov.id.toString() === formState.province.toString()
            )
            if (dist.districts) {
              setCity(dist.districts)
            }
          }
        }
      }
    }
  } catch (error) {}
}

export const CANDIDATE_DETAIL_DATA_FETCH = async (
  id,
  setProfile,
  setWholePageLoading
) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL +
        endpoints.COMPANY_CANDIDATE_PROFILE_ROUTE +
        id +
        "/"
    )
    const { data } = response
    setProfile(data)

    setWholePageLoading(false)
  } catch (err) {
    const code = err?.response?.status
    if (code === 500 || code === 400 || code === 404) {
      navigate("/404")
    } else {
      setWholePageLoading(false)
    }
  }
}
